import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ShieldCheck } from "lucide-react";

export function TermsAcceptedNote() {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/policies/current").then((r) => setP(r.data)).catch(() => {}); }, []);
  if (!p || !p.accepted_at) return null;
  const d = new Date(p.accepted_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
  return (
    <div data-testid="terms-accepted-note" className="mt-8 flex flex-wrap items-center gap-2 rounded-2xl border border-emerald-200 bg-emerald-50/60 px-4 py-3 text-sm">
      <ShieldCheck className="h-4 w-4 text-emerald-600" />
      <span className="font-medium text-emerald-800">Terms accepted on {d}</span>
      <span className="text-emerald-700/60">(v{p.accepted_version})</span>
      <Link to="/terms" className="ml-auto font-semibold text-emerald-700 hover:underline">View current Terms</Link>
    </div>
  );
}
